import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getGeneralStorage, setGeneralStorage} from '../middleware/dataStorage';
import {getData, postData} from '../middleware/apiMiddleware';
import s from './itemOrdering.module.css';
import ItemTypeIconModal from '../components/Modal/ItemTypeIconModal';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import {keyItemList} from '../middleware/MyConstant';
import {Image} from 'react-bootstrap';
import {GreenButton, BlueButton} from '../components/MyButton';

export default function ItemOrdering() {
	const navigate = useNavigate();
	
	const [keyData, setKeyData] = useState(keyItemList);
	const [items, setItems] = useState([]);
	const [target, setTarget] = useState();
	
	const fetchData = async (target) => {		
		setItems([]);
		
		getData('item/listAllItems?target=' + target, navigate)
		.then(res => {
				let items = res.data;
				for(let i of items) {
					i.itemId = i.itemId.toString();
				}
			setItems(items);
			
		});
	}
	
	
	const updateKeyItemOrdering = (target, newItems) => {
		let objs = [];
		
		for (let i = 0; i < newItems.length; i++) {
			objs.push({id:newItems[i].itemId, ordering:i});
		}
		
		let param = {
			target,
			items:objs
		}
		
		postData("item/updateKeyItemOrdering", param, navigate); 
	}
	
	const onDragEnd = async (result) => {
    if (!result.destination) return;
    const newItems = Array.from(items);
    const [removed] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, removed);
		updateKeyItemOrdering(target, newItems);
    setItems(newItems);
  };
	
	const pushToPosition = async (sourceIndex, targetIndex) => {
    const newItems = Array.from(items);
    const [removed] = newItems.splice(sourceIndex, 1);
    newItems.splice(targetIndex, 0, removed);
		updateKeyItemOrdering(target, newItems);
    setItems(newItems);
		
	}
	
	const chooseTarget = (target) => {
		setTarget(target);
		fetchData(target);
	}
	
	useEffect(() => {
	}, []);
	
	return (<div>
		
		<div className={s.header}>Published Item Ordering</div>
		
		<div>
			<div style={{display:"flex", background:"#fceecf", margin:"10px 0"}}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle}>
						<span style={{cursor:"pointer"}}>Key-Item</span>
					</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
				<div className={s.paramSectionHolder}>
					{
						keyData.map(
							(d, indexD) => (<>
								<div key={'ki-'+indexD} className={s.clickableOption}
									style={(target == d.searchKey) ? {background:"#ebccad"} : {}}
									onClick={() => {
										if (d.searchKey != target) {
											chooseTarget(d.searchKey)
										}
									}}>
									<ItemTypeIconModal itemType={d.itemType}/>
									<div>{d.title} </div>
								</div>
								{(indexD != keyData.length-1) &&(<span>•</span>)}
							</>)
						)
					}
				</div>
			</div>
		</div>
		
		<div>
			{
				<DragDropContext onDragEnd={onDragEnd}>
					<Droppable droppableId="items">
						{(provided) => (
							<div {...provided.droppableProps} ref={provided.innerRef} 
								style={{display:"flex", flexDirection:"column", gap:"2px", flexWrap: "wrap", alignItems:"center"}}>
								{items.map((item, index) => (
									<Draggable key={item.itemId} draggableId={item.itemId} index={index}>
										{(provided) => (
											<div
												{...provided.draggableProps}
												{...provided.dragHandleProps}
												ref={provided.innerRef}>
												<ItemDisplay item={item} index={index} itemSize={items.length} pushToPosition={pushToPosition}/>
											</div>
										)}
									</Draggable>
								))}
								{provided.placeholder}
							</div>
						)}
					</Droppable>
				</DragDropContext>
			}
		</div>
		
	</div>);
}

const ItemDisplay = ({item, index, itemSize, pushToPosition}) => {
	
	const greenButtonOverrideStyle={borderRadius:"0", margin:"2px", height:"3vh", padding:"0 2px"}
	
	return (<div style={{border:"1px solid #9db2be", display:"flex", minHeight:"25px", height:"4vh", width:"90vw", position:"relative", gap:"5px", alignItems:"center"}}>
		<div>
			<GreenButton overrideStyle={greenButtonOverrideStyle} isEnabled={true} clickedAction={()=>pushToPosition(index, itemSize-1)} bText={"To Bottom"} />
		</div>
		<div>
			<GreenButton overrideStyle={greenButtonOverrideStyle} isEnabled={true} clickedAction={()=>pushToPosition(index, 0)} bText={"To Top"} />
		</div>
		<div style={{overflow:"hidden"}}>
			<Image style={{width:"2vw", height:"3vh"}} fluid src={item.thumbnailPath} rounded />	
		</div>
		<div>{item.itemId}</div>
		{(item.isFree == 1) && (<div><div style={{borderRadius:"4px",  background:"#d8523d", color:"white", padding:"0 2px", fontWeight:"bold"}}>
			FREE
		</div></div>)}
		<div style={{overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis"}}>{item.name}</div>	
	</div>);
}
